import { combineReducers } from '@reduxjs/toolkit'
import { cashierAccessReducer } from './features/cashier-access/model/accessSlice'
import { cashierAnalyticsReducer } from './features/cashier-analytics/model/analyticsSlice'
import { cashierGroupsReducer } from './features/cashier-groups/model/groupsSlice'
import { salesPointsReducer } from './features/sales-points/model/salesPointsSlice'
import { ownCashiersReducer } from './features/own-cashiers/model/peopleSlice'

/**
 * Состояние модуля `receipts`: по слайсу намерения на каждую сущность (RP-SEP4). Общего слайса на всё нет —
 * здесь только склейка, ответов службы и секретов в состоянии нет.
 */
export const receiptsUiReducer = combineReducers({
  ownCashiers: ownCashiersReducer,
  cashierAccess: cashierAccessReducer,
  cashierGroups: cashierGroupsReducer,
  cashierAnalytics: cashierAnalyticsReducer,
  salesPoints: salesPointsReducer,
})
export type ReceiptsUiState = ReturnType<typeof receiptsUiReducer>
